/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-checkbox-checked .mat-checkbox-background{background-color:#75ba1d!important}  .mat-checkbox-ripple .mat-ripple-element{background-color:rgba(117,186,29,.26)!important}#descriptionField[_ngcontent-%COMP%]{width:90%}#parking[_ngcontent-%COMP%]{padding:10px}#charted[_ngcontent-%COMP%]{padding:10px 10px 20px}"];
export { styles as styles };
